var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-192.000000, -391.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled",
    transform: "translate(48.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-3",
    transform: "translate(0.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus",
    transform: "translate(144.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25,10.5 L13.5,10.5 L13.5,3.75 C13.5,3.335625 13.164375,3 12.75,3 L11.25,3 C10.835625,3 10.5,3.335625 10.5,3.75 L10.5,10.5 L3.75,10.5 C3.335625,10.5 3,10.835625 3,11.25 L3,12.75 C3,13.164375 3.335625,13.5 3.75,13.5 L10.5,13.5 L10.5,20.25 C10.5,20.664375 10.835625,21 11.25,21 L12.75,21 C13.164375,21 13.5,20.664375 13.5,20.25 L13.5,13.5 L20.25,13.5 C20.664375,13.5 21,13.164375 21,12.75 L21,11.25 C21,10.835625 20.664375,10.5 20.25,10.5 Z",
    id: "Icon",
    fill: "#191C24"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.be02e2c4.svg";
export { ForwardRef as ReactComponent };